import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {SheetDto} from "../document/sheet.dto";

export class SearchSheetRes extends SearchResultDto {

  public override readonly items: SearchSheetItem[] = [];

  constructor(init?: Partial<SearchSheetRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchSheetItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchSheetItem extends SheetDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchSheetItem>) {
    super(init);
    Object.assign(this, init);
  }

  isEditable(): boolean {
    return true;
  }
}
